import { ReactElement } from 'react';
import { AgentIconKey } from '@nx-frontend/shared/types/agent-icon';
import { AiSquareOutlineIcon } from './icons/ai-square-outline';
import { AnalyticsReportIcon } from './icons/analytics-report';
import { ArrowsTransformSparkleIcon } from './icons/arrows-transform-sparkle';
import { BadgeStarCircleIcon } from './icons/badge-star-circle';
import { BalancedScaleIcon } from './icons/balanced-scale';
import { BarChartUpIcon } from './icons/bar-chart-up';
import { BarChartVerticalIcon } from './icons/bar-chart-vertical';
import { BookSparkleIcon } from './icons/book-sparkle';
import { BotFaceAlienIcon } from './icons/bot-face-alien';
import { BotLightningIcon } from './icons/bot-lightning';
import { BriefcaseBusinessIcon } from './icons/briefcase-business';
import { BulletListIcon } from './icons/bullet-list';
import { ChartSparkleIcon } from './icons/chart-sparkle';
import { ChatBubbleSparkleIcon } from './icons/chat-bubble-sparkle';
import { ChatbotEditIcon } from './icons/chatbot-edit';
import { ChatbotFacePlainIcon } from './icons/chatbot-face-plain';
import { ChatbotOutlineIcon } from './icons/chatbot-outline';
import { ChatbotSearchIcon } from './icons/chatbot-search';
import { ChatbotSparkleIcon } from './icons/chatbot-sparkle';
import { ChatbotTextAiIcon } from './icons/chatbot-text-ai';
import { ClipboardChecklistIcon } from './icons/clipboard-checklist';
import { CubeSparkleIcon } from './icons/cube-sparkle';
import { CurvedDocSparkleIcon } from './icons/curved-doc-sparkle';
import { DatabaseCylinderIcon } from './icons/database-cylinder';
import { DesktopMonitorIcon } from './icons/desktop-monitor';
import { DocumentApprovedIcon } from './icons/document-approved';
import { DocumentCodeIcon } from './icons/document-code';
import { DocumentEditIcon } from './icons/document-edit';
import { DocumentFoldedIcon } from './icons/document-folded';
import { DocumentQuestionIcon } from './icons/document-question';
import { DocumentSearchIcon } from './icons/document-search';
import { DocumentSparkleIcon } from './icons/document-sparkle';
import { DocumentSparkleTopIcon } from './icons/document-sparkle-top';
import { DollarCircleSparkleIcon } from './icons/dollar-circle-sparkle';
import { DottedSquareSparkleIcon } from './icons/dotted-square-sparkle';
import { EnvelopePencilIcon } from './icons/envelope-pencil';
import { EnvelopeSparkleIcon } from './icons/envelope-sparkle';
import { FeatherWritingIcon } from './icons/feather-writing';
import { GlobeConnectivityIcon } from './icons/globe-connectivity';
import { GlobeInnovationSparkleIcon } from './icons/globe-innovation-sparkle';
import { GlobeNodesIcon } from './icons/globe-nodes';
import { GlobeSearchIcon } from './icons/globe-search';
import { GlobeSparkleIcon } from './icons/globe-sparkle';
import { GlobeWavesIcon } from './icons/globe-waves';
import { GlobeWorldwideIcon } from './icons/globe-worldwide';
import { GraduationCapIcon } from './icons/graduation-cap';
import { GridFourDotsIcon } from './icons/grid-four-dots';
import { HandHoldingCoinsIcon } from './icons/hand-holding-coins';
import { HandHoldingHeartIcon } from './icons/hand-holding-heart';
import { HandHoldingHeartAltIcon } from './icons/hand-holding-heart-alt';
import { HeadsetSupportIcon } from './icons/headset-support';
import { HeartHandshakeIcon } from './icons/heart-handshake';
import { HeartSparkleIcon } from './icons/heart-sparkle';
import { HexagonInnerSparkleIcon } from './icons/hexagon-inner-sparkle';
import { HexagonSparkleIcon } from './icons/hexagon-sparkle';
import { HighlightLinesSparkleIcon } from './icons/highlight-lines-sparkle';
import { KnotConnectionIcon } from './icons/knot-connection';
import { LaptopCodeIcon } from './icons/laptop-code';
import { LightbulbIdeaIcon } from './icons/lightbulb-idea';
import { LightningBoltIcon } from './icons/lightning-bolt';
import { LightningCircleIcon } from './icons/lightning-circle';
import { LightningMotionIcon } from './icons/lightning-motion';
import { LoopArrowsSparkleIcon } from './icons/loop-arrows-sparkle';
import { MagicPencilWavingIcon } from './icons/magic-pencil-waving';
import { MagicSparkleIcon } from './icons/magic-sparkle';
import { MagicWandWavingIcon } from './icons/magic-wand-waving';
import { MapPinPlatformIcon } from './icons/map-pin-platform';
import { MegaphoneAnnounceIcon } from './icons/megaphone-announce';
import { MicrochipAiIcon } from './icons/microchip-ai';
import { MicrochipCpuIcon } from './icons/microchip-cpu';
import { MonitorVideoPlayIcon } from './icons/monitor-video-play';
import { NotebookSparkleIcon } from './icons/notebook-sparkle';
import { OpenBookIcon } from './icons/open-book';
import { PencilWritingIcon } from './icons/pencil-writing';
import { PercentSignIcon } from './icons/percent-sign';
import { PersonEnvelopeIcon } from './icons/person-envelope';
import { PersonInHandIcon } from './icons/person-in-hand';
import { PointingToCenterIcon } from './icons/pointing-to-center';
import { PresentationChartIcon } from './icons/presentation-chart';
import { PuzzlePieceIcon } from './icons/puzzle-piece';
import { RefreshArrowsSparkleIcon } from './icons/refresh-arrows-sparkle';
import { RefreshSparkleIcon } from './icons/refresh-sparkle';
import { RobotFaceAntennaeIcon } from './icons/robot-face-antennae';
import { RobotFaceSquareIcon } from './icons/robot-face-square';
import { RocketLaunchIcon } from './icons/rocket-launch';
import { ScanAreaSparkleIcon } from './icons/scan-area-sparkle';
import { ScanDetectIcon } from './icons/scan-detect';
import { ScanningSparkleIcon } from './icons/scanning-sparkle';
import { ShieldCheckmarkIcon } from './icons/shield-checkmark';
import { ShieldLightningIcon } from './icons/shield-lightning';
import { ShieldSparkleIcon } from './icons/shield-sparkle';
import { SignatureIcon } from './icons/signature-icon';
import { SingleSparkleIcon } from './icons/single-sparkle';
import { SmileySquareIcon } from './icons/smiley-square';
import { SparkleDashedCircleIcon } from './icons/sparkle-dashed-circle';
import { SparkleShineIcon } from './icons/sparkle-shine';
import { SpeechBubbleEditIcon } from './icons/speech-bubble-edit';
import { SpeechBubblePromptIcon } from './icons/speech-bubble-prompt';
import { SpeechBubbleQuestionIcon } from './icons/speech-bubble-question';
import { SpeechBubbleQuestionAltIcon } from './icons/speech-bubble-question-alt';
import { SpeechBubbleQuestionAlt2Icon } from './icons/speech-bubble-question-alt2';
import { SpeechBubbleSparklesIcon } from './icons/speech-bubble-sparkles';
import { SquareBoltIcon } from './icons/square-bolt';
import { SquareFourDotsIcon } from './icons/square-four-dots';
import { SquareRootXIcon } from './icons/square-root-x';
import { SquareSparkleCenterIcon } from './icons/square-sparkle-center';
import { StackedLayersDiamondIcon } from './icons/stacked-layers-diamond';
import { StarInStarIcon } from './icons/star-in-star';
import { SwirlLogoAiIcon } from './icons/swirl-logo-ai';
import { SwirlSynergyIcon } from './icons/swirl-synergy';
import { TargetArrowIcon } from './icons/target-arrow';
import { TargetFocusIcon } from './icons/target-focus';
import { TargetPersonIcon } from './icons/target-person';
import { TerminalCodeIcon } from './icons/terminal-code';
import { TextAiStarIcon } from './icons/text-ai-star';
import { TextDetectionIcon } from './icons/text-detection';
import { TextFormatSparkleIcon } from './icons/text-format-sparkle';
import { TextLayoutIcon } from './icons/text-layout';
import { TranslationIcon } from './icons/translation-icon';
import { TrophyAchievementIcon } from './icons/trophy-achievement';
import { UserProfileFrameIcon } from './icons/user-profile-frame';
import { UserSearchIcon } from './icons/user-search';
import { UserSparkleIcon } from './icons/user-sparkle';
import { UserVerifiedIcon } from './icons/user-verified';
import { VideoPlaySparkleIcon } from './icons/video-play-sparkle';

export const AgentIconsMap: Record<AgentIconKey, ReactElement> = {
  TEXT_AI_STAR: <TextAiStarIcon />,
  AI_SQUARE_OUTLINE: <AiSquareOutlineIcon />,
  SPARKLE_SHINE: <SparkleShineIcon />,
  ROBOT_FACE_SQUARE: <RobotFaceSquareIcon />,
  DOTTED_SQUARE_SPARKLE: <DottedSquareSparkleIcon />,
  SPARKLE_DASHED_CIRCLE: <SparkleDashedCircleIcon />,
  CHART_SPARKLE: <ChartSparkleIcon />,
  BADGE_STAR_CIRCLE: <BadgeStarCircleIcon />,
  SPEECH_BUBBLE_PROMPT: <SpeechBubblePromptIcon />,
  SQUARE_SPARKLE_CENTER: <SquareSparkleCenterIcon />,
  GRID_FOUR_DOTS: <GridFourDotsIcon />,
  DOCUMENT_CODE: <DocumentCodeIcon />,
  REFRESH_SPARKLE: <RefreshSparkleIcon />,
  // line 2
  MAGIC_SPARKLE: <MagicSparkleIcon />,
  SPEECH_BUBBLE_SPARKLES: <SpeechBubbleSparklesIcon />,
  SQUARE_FOUR_DOTS: <SquareFourDotsIcon />,
  DATABASE_CYLINDER: <DatabaseCylinderIcon />,
  DOCUMENT_SPARKLE: <DocumentSparkleIcon />,
  SPEECH_BUBBLE_QUESTION: <SpeechBubbleQuestionIcon />,
  BOOK_SPARKLE: <BookSparkleIcon />,
  NOTEBOOK_SPARKLE: <NotebookSparkleIcon />,
  CURVED_DOC_SPARKLE: <CurvedDocSparkleIcon />,
  MAGIC_WAND_WAVING: <MagicWandWavingIcon />,
  MAGIC_PENCIL_WAVING: <MagicPencilWavingIcon />,
  STACKED_LAYERS_DIAMOND: <StackedLayersDiamondIcon />,
  HEADSET_SUPPORT: <HeadsetSupportIcon />,
  // line 3
  PERSON_IN_HAND: <PersonInHandIcon />,
  USER_SEARCH: <UserSearchIcon />,
  CLIPBOARD_CHECKLIST: <ClipboardChecklistIcon />,
  ANALYTICS_REPORT: <AnalyticsReportIcon />,
  ROCKET_LAUNCH: <RocketLaunchIcon />,
  BALANCED_SCALE: <BalancedScaleIcon />,
  PERCENT_SIGN: <PercentSignIcon />,
  TARGET_ARROW: <TargetArrowIcon />,
  MEGAPHONE_ANNOUNCE: <MegaphoneAnnounceIcon />,
  LIGHTNING_BOLT: <LightningBoltIcon />,
  LIGHTNING_MOTION: <LightningMotionIcon />,
  PUZZLE_PIECE: <PuzzlePieceIcon />,
  TERMINAL_CODE: <TerminalCodeIcon />,
  // line 4
  USER_PROFILE_FRAME: <UserProfileFrameIcon />,
  DOCUMENT_SEARCH: <DocumentSearchIcon />,
  DOCUMENT_APPROVED: <DocumentApprovedIcon />,
  BAR_CHART_UP: <BarChartUpIcon />,
  PRESENTATION_CHART: <PresentationChartIcon />,
  DESKTOP_MONITOR: <DesktopMonitorIcon />,
  SHIELD_LIGHTNING: <ShieldLightningIcon />,
  TRANSLATION_ICON: <TranslationIcon />,
  BAR_CHART_VERTICAL: <BarChartVerticalIcon />,
  TEXT_DETECTION: <TextDetectionIcon />,
  SPEECH_BUBBLE_QUESTION_ALT: <SpeechBubbleQuestionAltIcon />,
  SIGNATURE_ICON: <SignatureIcon />,
  MAP_PIN_PLATFORM: <MapPinPlatformIcon />,
  // line 5
  SCAN_DETECT: <ScanDetectIcon />,
  VIDEO_PLAY_SPARKLE: <VideoPlaySparkleIcon />,
  CHAT_BUBBLE_SPARKLE: <ChatBubbleSparkleIcon />,
  BULLET_LIST: <BulletListIcon />,
  SPEECH_BUBBLE_QUESTION_ALT2: <SpeechBubbleQuestionAlt2Icon />,
  GLOBE_SPARKLE: <GlobeSparkleIcon />,
  LOOP_ARROWS_SPARKLE: <LoopArrowsSparkleIcon />,
  DOCUMENT_SPARKLE_TOP: <DocumentSparkleTopIcon />,
  ENVELOPE_SPARKLE: <EnvelopeSparkleIcon />,
  SMILEY_SQUARE: <SmileySquareIcon />,
  HEART_SPARKLE: <HeartSparkleIcon />,
  USER_SPARKLE: <UserSparkleIcon />,
  SHIELD_SPARKLE: <ShieldSparkleIcon />,
  // line 6
  GLOBE_INNOVATION_SPARKLE: <GlobeInnovationSparkleIcon />,
  OPEN_BOOK: <OpenBookIcon />,
  ARROWS_TRANSFORM_SPARKLE: <ArrowsTransformSparkleIcon />,
  GRADUATION_CAP: <GraduationCapIcon />,
  CUBE_SPARKLE: <CubeSparkleIcon />,
  BOT_FACE_ALIEN: <BotFaceAlienIcon />,
  BOT_LIGHTNING: <BotLightningIcon />,
  TEXT_LAYOUT: <TextLayoutIcon />,
  GLOBE_WAVES: <GlobeWavesIcon />,
  SCANNING_SPARKLE: <ScanningSparkleIcon />,
  SQUARE_ROOT_X: <SquareRootXIcon />,
  SHIELD_CHECKMARK: <ShieldCheckmarkIcon />,
  GLOBE_CONNECTIVITY: <GlobeConnectivityIcon />,
  // line 7
  HEART_HANDSHAKE: <HeartHandshakeIcon />,
  TARGET_PERSON: <TargetPersonIcon />,
  PERSON_ENVELOPE: <PersonEnvelopeIcon />,
  ENVELOPE_PENCIL: <EnvelopePencilIcon />,
  LAPTOP_CODE: <LaptopCodeIcon />,
  LIGHTBULB_IDEA: <LightbulbIdeaIcon />,
  GLOBE_SEARCH: <GlobeSearchIcon />,
  MONITOR_VIDEO_PLAY: <MonitorVideoPlayIcon />,
  SWIRL_SYNERGY: <SwirlSynergyIcon />,
  HAND_HOLDING_HEART: <HandHoldingHeartIcon />,
  LIGHTNING_CIRCLE: <LightningCircleIcon />,
  SQUARE_BOLT: <SquareBoltIcon />,
  GLOBE_NODES: <GlobeNodesIcon />,
  // line 8
  TARGET_FOCUS: <TargetFocusIcon />,
  USER_VERIFIED: <UserVerifiedIcon />,
  DOCUMENT_QUESTION: <DocumentQuestionIcon />,
  TEXT_FORMAT_SPARKLE: <TextFormatSparkleIcon />,
  ROBOT_FACE_ANTENNAE: <RobotFaceAntennaeIcon />,
  CHATBOT_EDIT: <ChatbotEditIcon />,
  CHATBOT_SEARCH: <ChatbotSearchIcon />,
  CHATBOT_FACE_PLAIN: <ChatbotFacePlainIcon />,
  CHATBOT_SPARKLE: <ChatbotSparkleIcon />,
  CHATBOT_OUTLINE: <ChatbotOutlineIcon />,
  SCAN_AREA_SPARKLE: <ScanAreaSparkleIcon />,
  DOLLAR_CIRCLE_SPARKLE: <DollarCircleSparkleIcon />,
  MICROCHIP_AI: <MicrochipAiIcon />,
  // line 9
  HEXAGON_SPARKLE: <HexagonSparkleIcon />,
  CHATBOT_TEXT_AI: <ChatbotTextAiIcon />,
  HIGHLIGHT_LINES_SPARKLE: <HighlightLinesSparkleIcon />,
  KNOT_CONNECTION: <KnotConnectionIcon />,
  HEXAGON_INNER_SPARKLE: <HexagonInnerSparkleIcon />,
  SWIRL_LOGO_AI: <SwirlLogoAiIcon />,
  STAR_IN_STAR: <StarInStarIcon />,
  SPEECH_BUBBLE_EDIT: <SpeechBubbleEditIcon />,
  FEATHER_WRITING: <FeatherWritingIcon />,
  DOCUMENT_EDIT: <DocumentEditIcon />,
  BRIEFCASE_BUSINESS: <BriefcaseBusinessIcon />,
  HAND_HOLDING_HEART_ALT: <HandHoldingHeartAltIcon />,
  SINGLE_SPARKLE: <SingleSparkleIcon />,
  // line 10
  TROPHY_ACHIEVEMENT: <TrophyAchievementIcon />,
  GLOBE_WORLDWIDE: <GlobeWorldwideIcon />,
  HAND_HOLDING_COINS: <HandHoldingCoinsIcon />,
  MICROCHIP_CPU: <MicrochipCpuIcon />,
  PENCIL_WRITING: <PencilWritingIcon />,
  POINTING_TO_CENTER: <PointingToCenterIcon />,
  DOCUMENT_FOLDED: <DocumentFoldedIcon />,
  REFRESH_ARROWS_SPARKLE: <RefreshArrowsSparkleIcon />,
};

export const getDefaultAgentIconKey = () => {
  return AgentIconsMap.TEXT_AI_STAR;
};
